module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-1dddb592!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-flatpickr.vue
// module id = 12
// module chunks = 0